var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconDesign(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons=Design"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M18.7501 9.39999L14.6001 5.24999L16.1126 3.72499C16.4709 3.36665 16.9126 3.18749 17.4376 3.18749C17.9626 3.18749 18.4043 3.36665 18.7626 3.72499L20.2751 5.23749C20.6334 5.59582 20.8126 6.03749 20.8126 6.56249C20.8126 7.08749 20.6334 7.52915 20.2751 7.88749L18.7501 9.39999ZM3.0626 20.9375V16.775L7.5876 12.25L2.2876 6.93749L6.9626 2.29999L12.2501 7.61249L14.6001 5.24999L18.7501 9.39999L16.4001 11.75L21.6876 17.05L17.0626 21.7125L11.7501 16.4L7.2251 20.9375H3.0626ZM8.9251 10.925L10.9126 8.93749L9.6251 7.64999L8.4251 8.83749L7.1126 7.52499L8.3001 6.32499L6.9251 4.96249L4.9501 6.94999L8.9251 10.925ZM17.0501 19.0375L19.0376 17.05L17.6876 15.7125L16.5001 16.9L15.1626 15.575L16.3626 14.375L15.0626 13.0875L13.0751 15.075L17.0501 19.0375ZM4.9376 19.0625H6.4251L16.1001 9.39999L14.6001 7.89999L4.9376 17.575V19.0625Z",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDesign);
export default __webpack_public_path__ + "static/media/icon-design.158881a5f3b6c9d1acafe4af50a49a18.svg";
export { ForwardRef as ReactComponent };